import cx from "classnames";

import styles from "./Loader.module.scss";

const Loader = ({ className, height = 14 }) => {
  return (
    <div className={cx(className, styles.Loader)}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src="../icon-circle-notch-solid.svg" height={height} alt="loader" />
    </div>
  );
};

export default Loader;
